/** @format */

/**
 * In-memory flag for the current page lifetime (resets on full reload).
 * Prevents duplicate `language` pushes from dashboard remounts / Strict Mode,
 * and skips `language` after `language_changed` on the same load.
 */
let languageEventTracked = false;

/**
 * True until the first `language` / `language_changed` dataLayer push in this page load.
 */
export function shouldTrackLanguageEvent(): boolean {
  return !languageEventTracked;
}

export function markLanguageEventTracked(): void {
  languageEventTracked = true;
}

export function clearLanguageEventTracked(): void {
  languageEventTracked = false;
}
